<script setup lang="ts">
import UiIcon from '../UiIcon.vue'

interface Props {
    comboboxValue: string[]
    getLabel: (value: string) => string
}

defineProps<Props>()

const emit = defineEmits<{
    (e: 'remove', value: string): void
}>()
</script>

<template>
    <div 
        v-if="comboboxValue.length > 0"
        class="flex flex-wrap gap-1"
    >
        <span
            v-for="value in comboboxValue"
            :key="value"
            class="inline-flex items-center gap-1 px-2 py-0.5 bg-se-primary/10 text-se-dark rounded text-sm"
        >
            {{ getLabel(value) }}
            <button
                type="button"
                @click.stop="emit('remove', value)"
                class="hover:bg-se-primary/20 rounded-full p-0.5"
                aria-label="Remove"
            >
                <UiIcon name="close" class="w-3 h-3" />
            </button>
        </span>
    </div>
</template>

